
import { useState, useEffect, useRef } from "react";
import "./BacklightToggle.scss";

const BacklightToggle = () => {
    const [isOn, setIsOn] = useState(false);

    // useEffect(() => {
    //     if (window.scene && typeof window.scene.groupApplyState === "function") {
    //         window.scene.groupApplyState("backlit_off");
    //     }
    // }, []);
    
    const handleToggle = () => {
        const nextState = !isOn;
        setIsOn(nextState);
        if (window.scene && typeof window.scene.groupApplyState === "function") {
            window.scene.groupApplyState(nextState ? "backlit_on" : "backlit_off");
        }
    };

    return (
        <div className="backlightToggle" onClick={(e) => e.stopPropagation()}>
            <div className="toggleLabel">
                Check it out
            </div>
            <div
                className={`toggleTrack ${isOn ? "on" : "off"}`}
                onClick={handleToggle}
                role="button"
                tabIndex={0}
                aria-checked={isOn}
                aria-label="Backlight toggle"
                onKeyDown={(e) => e.key === "Enter" && handleToggle()}
            >
                <div className="toggleInnerPill">
                    <span className="toggleText">{isOn ? "ON" : "OFF"}</span>
                    <div className="toggleKnob"></div>
                </div>
            </div>
        </div>
    );
};

export default BacklightToggle;